<template>
  <div v-if="purchase.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('Purchases', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/purchases/detail/' + purchase.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("PurchasesList.actions.detail") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("PurchasesList.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 取消 -->
      <v-tooltip
        top
        v-if="showCancel && $permission.permissionAllow('Purchases', 'cancel')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancel = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("PurchasesList.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("PurchasesList.actions.cancel") }}</span>
      </v-tooltip>
      <!-- 查收 -->
      <v-tooltip top v-if="showCheck">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click="doAction('check')"
          >
            {{ $t("Delivery.Fields.check") }}
          </v-btn>
        </template>
        <span>{{ $t("Delivery.Fields.check") }}</span>
      </v-tooltip>
      <!-- 发货 -->
      <v-tooltip top v-if="showDelivery">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click="delivery(purchase.id)"
          >
            {{ $t("Delivery.Fields.delivery") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Delivery.Fields.delivery")]) }}</span>
      </v-tooltip>
    </v-sheet>

    <!-- 弹窗 -->
    <DialogPurchases
      v-model="cancel"
      cancel-mode
      :label="$t('PurchasesList.Fields.purchase_code')"
      :code="purchase.purchase_code"
      @confirm="
        doAction('cancel');
        cancel = false;
      "
    />
  </div>
</template>

<script>
import DialogPurchases from "@/components/plugins/DialogPurchases";
import Purchases from "@/api/purchases";
import { mapState } from "vuex";
import Delivery from "@/api/delivery";

export default {
  name: "StockDetailsActions",

  props: {
    detailMode: Boolean,
    purchase: Object,
    showView: Boolean,
    showCancel: Boolean,
    showCheck: Boolean,
    showDelivery: Boolean,
  },
  components: {
    DialogPurchases,
  },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    logisticAlert: false,
    cancel: false,
    clone: false,
    cancelProhibit: false,
    cancelUnProhibit: false,
    dialog: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "cancel") return Purchases.cancel(this.purchase.id);
      if (mode == "check") return Delivery.check(this.purchase.id);
    },
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    delivery(e) {
      this.$router.replace("/purchases/edit/" + e);
    },
  },
};
</script>